import request from './requestServices';
import {
  API_PROJECT_CREATE_URL,
  API_PROJECT_RM_URL,
  API_PROJECT_LIST_URL,
  API_PROJECT_RENAME_URL,
  API_PROJECT_DETAIL_URL
} from './apiRoutes';

export async function createProject(projectName, description = '') {
  const { data } = await request(API_PROJECT_CREATE_URL, {
    method: 'POST',
    data: { 
      name: projectName, 
      description 
    },
  });
  // data.data now contains { project_id, knowledgebases }
  return data.data;
}

export async function removeProject(projectId) {
  const { data } = await request(API_PROJECT_RM_URL, {
    method: 'POST',
    data: { project_id: projectId },
  });
  // e.g. data => true/false
  return data.data;
}

export async function renameProject(projectId, newName) {
  const { data } = await request(API_PROJECT_RENAME_URL, {
    method: 'POST',
    data: { 
      project_id: projectId,
      name: newName 
    },
  });
  // e.g. data => true/false
  return data.data;
}

export async function getProjectDetail(projectId) {
  const { data } = await request(`${API_PROJECT_DETAIL_URL}?project_id=${projectId}`, {
    method: 'GET',
  });
  return data.data; // => project detail object
}

export async function updateProjectDetail(projectId, description) {
  const { data } = await request(API_PROJECT_DETAIL_URL, {
    method: 'POST',
    data: { 
      project_id: projectId,
      description
    },
  });
  return data.data; // => true/false
}

export async function listProjects() {
  const { data } = await request(API_PROJECT_LIST_URL, {
    method: 'GET',
  });
  // e.g. data => [ { id, tenant_id, name, ... }, ... ]
  return data.data; // => array of projects
} 